/**
 * English strings for voice-chat-ui components
 * This is the default language and source of truth for all UI copy
 */
export const strings = {
  startSheet: {
    defaultTitle: "Hi there,",
    defaultBody: `Thanks for taking a few minutes today.

We'll explain everything you need to know on the call and you'll have a chance to review the draft before we share it.

Let's get started!`,
    voiceChatTitle: "This will be a voice chat",
    voiceChatDescription:
      "Find a quiet spot and get comfortable — this will be a short conversation.",
    micPermissionHint: "We'll ask for microphone permission when you start.",
    defaultPermissionDenied:
      "Please enable microphone access in your browser settings.",
    buttonLoading: "Starting...",
    buttonEnableMic: "Enable Mic & Start Call",
    buttonStart: "Start Call",
  },

  pausedSheet: {
    title: "Coffee Break?",
    description1: "No problem! You can return to your session at any time.",
    description2:
      "You can reconnect to continue now, or we'll send you an email with a link to resume your session later.",
    buttonReconnecting: "Reconnecting...",
    buttonReconnect: "Reconnect",
  },

  interruptedSheet: {
    title: "Connection Interrupted",
    description1:
      "Your session was interrupted unexpectedly. This could be due to a network issue or other technical problem.",
    description2:
      "Don't worry — your progress has been saved. You can reconnect now to continue where you left off.",
    buttonReconnecting: "Reconnecting...",
    buttonReconnect: "Reconnect",
  },

  completeSheet: {
    title: "Session Complete!",
    description1:
      "Thank you for completing the call. Your responses have been recorded and saved.",
    description2: "We'll be in touch soon with next steps.",
    closeHint: "You can close this window now.",
  },

  liveControls: {
    connecting: "Connecting...",
    connectionLost: "Connection lost - tap to reconnect",
    connectionError: "Connection error",
    disconnected: "Disconnected",
    networkWarning: "Your network is causing poor call quality",
    permissionNeeded: "Permission needed",
    muteMic: "Mute microphone",
    unmuteMic: "Unmute microphone",
    pauseInterview: "Pause interview",
    reconnect: "Reconnect",
  },

  conversationStatus: {
    listening: "Listening",
    thinking: "Thinking",
  },

  deviceSelector: {
    microphone: "Microphone",
    speaker: "Speaker",
    noDevicesFound: "No devices found",
    checkMicPermissions: "Check browser permissions to grant microphone access",
    checkSpeakerPermissions:
      "Check browser permissions to grant speaker access",
    micAccessRequired: "Microphone access required",
    grantPermission: "Please grant permission in your browser settings",
    deviceSettings: "Device settings",
  },

  emptyState: {
    title: "No messages yet",
    description: "Start a conversation to see messages here",
  },
} as const;

export type Strings = typeof strings;
